import { COLORS, FONTS } from '@app/src/ui';
import styled from 'styled-components';

interface Props {
  active?: boolean;
}

interface ButtonProps {
  disabled?: boolean;
}

const ROOT = 'common/paginator/Paginator';

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  margin-bottom: 20px;
  justify-content: flex-end;
  color: ${COLORS.GRAY_TEXT};
  font-family: ${FONTS.ROBOTO};
  font-family: 15px;
  line-height: 28px;
`;

Wrapper.className = `${ROOT}/Wrapper`;

export const ButtonBefore = styled.span`
  margin-right: 8px;
  display: flex;
  cursor: pointer;

  ${(props: ButtonProps) => props.disabled && `
    opacity: .6;
    cursor: not-allowed;
  `}
`;

ButtonBefore.className = `${ROOT}/ButtonBefore`;

export const ButtonNext = styled.span`
  margin-left: 8px;
  cursor: pointer;
  display: flex;

  ${(props: ButtonProps) => props.disabled && `
    opacity: .6;
    cursor: not-allowed;
  `}
`;

ButtonNext.className = `${ROOT}/ButtonNext`;

export const Page = styled.span`
  display: flex;
  width: 44px;
  height: 44px;
  border-radius: 100%;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  ${(props: Props) => props.active && `
    background: #EBEBEB;
    color: ${COLORS.BLACK};
  `}
`;

Page.className = `${ROOT}/Page`;

export const IconBefore = styled.div`
  transform: rotate(90deg);
  margin-right: 8px;
  svg {
    pointer-events: none;
  }
`;

IconBefore.className = `${ROOT}/IconBefore`;

export const IconNext = styled.div`
  margin-left: 8px;
  transform: rotate(270deg);
  svg {
    pointer-events: none;
  }
`;

IconNext.className = `${ROOT}/IconNext`;
